import { sortOrderObj } from "./data";

export const getHoursandMinutes = (timespan) => {
    let hours = timespan;
    let minutes;
if(timespan){
   const [hoursStr, minutesStr] = timespan?.toString()?.split(":");
   const hoursC = parseInt(hoursStr, 10); // Parse hours as an integer
   minutes = parseInt(minutesStr, 10); // Parse minutes as an integer
   hours = (hoursC ?? 0) + (minutes ? (minutes/60) : 0) 
} 
return `${(hours && minutes) ? hours.toFixed(2) : (hours ?? "")} hours`;
};

export const getSortOrder = (orderType) => {
    const sortType =
    orderType === sortOrderObj.upArrow
        ? sortOrderObj.downArrow
        : orderType === sortOrderObj.downArrow
        ? sortOrderObj.upArrow
        : sortOrderObj.clearFilter;
        return sortType;
  };
  
  export const getDateJsFormat = (date) => {
    const [year, month, day] = date.split("-");
    return new Date(year, month - 1, day);
  };
  